/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Resetpasswordsubmit2Inputs */



/**

* @param {_Login_Resetpasswordsubmit2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_resetpasswordsubmit2 = /** @type {((inputs?: _Login_Resetpasswordsubmit2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Resetpasswordsubmit2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Abschicken!")
});
export { _login_resetpasswordsubmit2 as "_login_resetPasswordSubmit" }